import { updatesData } from '@/mocks/home';

const labelColors: Record<string, string> = {
  '上新': 'bg-primary-100 text-primary-700',
  '同步': 'bg-accent-100 text-accent-700',
  '热播': 'bg-red-100 text-red-700',
  '专题': 'bg-secondary-100 text-secondary-700',
  '推荐': 'bg-amber-100 text-amber-700',
  '活动': 'bg-pink-100 text-pink-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            第一时间掌握各平台影视更新与专题活动
          </p>
        </div>
        <div className="max-w-[900px] mx-auto">
          {updatesData.map((item, i) => (
            <a
              key={i}
              href={item.href}
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector(item.href);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-start gap-4 py-4 border-b border-background-200/50 last:border-b-0 hover:bg-background-100/50 rounded-lg px-3 -mx-3 transition-colors cursor-pointer group"
            >
              <div className="flex-shrink-0 w-16 text-right">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
              </div>
              <div className="flex-shrink-0">
                <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${labelColors[item.label] || 'bg-background-200 text-foreground-600'}`}>
                  {item.label}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-sm text-foreground-700 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}